module.exports = __webpack_public_path__ + "static/img/img07.e8cb50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img07.png
// module id = 6yHv
// module chunks = 1